import React from 'react'
import Link from 'gatsby-link'
var _utag = null;

export function set_content_type()  
{
    try {
        utag.content_type = "slideshow";
        utag.primary_tag = "Ultras Mundial, Racismo en la otra cara del Mundial de Rusia 2018.";
    }catch(errr){}
}
export function track_click($tag_name)
{
    set_content_type();
    _utag.link({ 
        event : 'other', 
        promo_type : 'other', 
        promo_loc : 'https://www.univision.com' + process.env.PREFIX_PATH, 
        promo_name : $tag_name
    });
}
export default class Tracking extends React.Component {

    track_event(text)
    {
        console.log("hola hola " + text)
    }

    componentDidMount()
    {
        var localComplet = new Date();
        var timestamp = String(Date.parse(new Date()));
        var epoch = parseInt(String(Date.now()).substr(0, 10));
        var timestamp_local = String(localFormat(localComplet));
        var timestamp_utc = String(localComplet.toISOString());

        function pad(number) { if (number < 10) { return "0" + number; } return number; }
        function localFormat(item) { return (item.getFullYear() +"-" + pad(item.getMonth() + 1) + "-" +pad(item.getDate()) +"T" +pad(item.getHours()) +":" +pad(item.getMinutes()) +":" +pad(item.getSeconds()) +"." +(item.getMilliseconds() / 1000).toFixed(3).slice(2, 5)); }
        function isMobile() { if ( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) &&window.innerWidth <= 1023) {return true;} else {return false;} }

        let page_name = this.props.pageName == undefined ? "ultras mundial racismo en la otra cara del mundial de rusia 2018" : this.props.pageName;
        let permalink = this.props.permalink == undefined ? "https://www.univision.com" + process.env.PREFIX_PATH : this.props.permalink;

        window.utag_data = {
            all_tags:["mundial rusia 2018","competencias de futbol","futbol","deportes", "la otra cara del mundial"],
            content_author:"",
            content_created_date:"2017-11-30",
            content_creator:"00000156-9f3a-d4c7-a957-dfbb097f0000",
            content_id:"00000160-0dcf-df73-ab77-7ddfc9470000",
            content_modified_date:"2017-11-30",
            content_priority:"standard",
            content_type:"article",
            enh_count:1,
            environment_name:"production",
            language:"es",
            page_name:"univision:mundial rusia 2018:article:" + page_name,
            parent_tags:["mundial rusia 2018", "competencias de futbol", "futbol", "deportes"],
            parent_topic:"deportes",
            permalink:permalink,
            portal_theme:"deportes:webapp",
            primary_tag:"mundial rusia 2018",
            primary_tag_uid:"0000015f-7419-d66d-a3df-7fb9b4f60000",
            primary_tag_en:"mundial rusia 2018",
            promo_title:"" + page_name,
            pub_name:"juan jorge hernandez",
            publisher_tags:["mundial rusia 2018", "la otra cara del mundial"],
            short_title:"" + page_name,
            short_title_en:"" + page_name,
            source:"univisiondeportes.com",
            tags_en:["mundial rusia 2018", "soccer competitions", " soccer", "sports", "la otra cara del mundial"],
            title:"" + page_name,
            title_en:"" + page_name,
            topics:["deportes"],
            uci_division:"uim-product",
            website:"univision",
            word_count:"1",
            uni_platform:"Website",
            country_code:"co",
            page_load_timestamp:timestamp,
            page_title:page_name + " - univision",
            login_status:"false",
            mvpd_provider:"false",
            embedded_items:"allgridfouritems",
            "qp.layout":"webapp",
            tealium_event:"view",
            tealium_visitor_id:"0161f827bf450002ac73842b6d2904079002207100ac2",
            tealium_session_id:"1527725311959",
            tealium_datasource:"",
            tealium_account:"univision",
            tealium_profile:"main",
            tealium_environment:"prod",
            tealium_random:"6173394453456569",
            tealium_library_name:"utag.js",
            tealium_library_version:"4.42.0",
            tealium_timestamp_epoch:epoch,
            tealium_timestamp_utc:timestamp_utc,
            tealium_timestamp_local:timestamp_local,
            "js_page.UVN.isDesktop":!isMobile(),
            "js_page.UVN.isMobile": isMobile(),
            ga_property_id:"UA-81851967-1",
            undefined:"",
            comments_flag:"",
            event:"",
            url:"",
            video_id:"",
            page_section:"mundial rusia 2018:article",
            uni_now_date:epoch,
            uni_tealium_ver:"ut4.42.201805021812",
            user_agent:navigator.userAgent,
            video_position:null,
            article_view:"1",
            word_count_group:"0-200",
            cb_multiple_sections:"mundial rusia 2018,competencias de futbol,futbol,deportes,article",
            webapp:"webapp"
        }

        var ele1 = document.createElement('script');
        ele1.src = '//tags.tiqcdn.com/utag/univision/main/prod/utag.js'; 
        ele1.type = 'text/javascript'; 
        ele1.async = true;
        document.head.appendChild(ele1);
        ele1.addEventListener("load", () => {
            _utag = utag;
        })
    }
    render() {
        return <div id="tracking-utag" />
    }
}



// WEBPACK FOOTER //
// ./src/components/tracking.js